<template>
  <div class="contract-complete-list">
    <TagsCloud ref="cloudtage" @cloudTages="cloudTages" />
    <div class="manage-table">
      <avue-crud
        :option="tableConfig"
        :data="tableData"
        v-model="searchForm"
        :page.sync="page"
        :search.sync="searchForm"
        @search-reset="searchReset"
        @on-load="queryTableData"
        @search-change="searchChange"
        @sort-change="sortChange"
        @refresh-change="queryTableData"
        @selection-change="selectionChange"
      >
        <template slot="searchMenu" slot-scope="{ row }">
          <el-button type="primary" @click="save(row)">保存</el-button>
          <!-- <el-button type="primary"  @click="openFilter">
                        <a-icon type="filter" /> 高级筛选
                    </el-button> -->
        </template>

        <template slot="menuLeft">
          <el-button
            size="small"
            type="primary"
            @click="handleAdd()"
            v-if="permission.contractComplete_add"
          >
            申请结清
          </el-button>
          <el-button
            size="small"
            type="primary"
            plain
            @click="handleEdit()"
            v-if="permission.contractComplete_edit"
          >
            编辑
          </el-button>
          <el-button
            type="danger"
            size="small"
            icon="el-icon-delete"
            plain
            @click.stop="handleDelete()"
            v-if="permission.contractComplete_delete"
            >删除
          </el-button>
          <el-button size="small" icon="el-icon-download" @click="exportShow"
            >导出数据
          </el-button>
        </template>

        <template slot="contractName" slot-scope="{ row }">
          <div class="project-name" @click="goDetail(row)">
            {{ row.contractName }}
          </div>
        </template>

        <template slot="contractNameSearch">
          <CommonSelect
            bindLabel="contractName"
            bindKey="id"
            bindValue="contractName"
            methods="get"
            dataMethod="params"
            dataUrl="bl/blcontractfinish/page"
            @handleChange="setContract"
          />
        </template>

        <template slot="sellerCustNameSearch">
          <CommonSelect
            bindLabel="custName"
            bindKey="id"
            bindValue="custName"
            methods="get"
            dataMethod="params"
            dataUrl="bl/custbasicinformationbl/page"
            @handleChange="setSellerCust"
          />
        </template>
      </avue-crud>
    </div>

    <SelectPerson
      ref="selectperson"
      :checkUserList="checkUserList"
      :isOnly="true"
      :clear="false"
      @setPeople="setPeople"
    />

    <ExportData ref="exportData" @exportDownload="exportDownload" />
  </div>
</template>
<script>
import { contractCompleteListConfig } from "./completeConfig.js";
import { downLoadTemplate } from "@/router/downLoadTem";
import { completeList, completeDelete } from "@/api/factoring/factoring";
import CommonSelect from "@/components/commonSelect/commonSelect";
import TableList from "@/components/tableListComponents/table";
import TagsCloud from "@/components/TagsCloud/TagsCloud";
import ExportData from "@/components/exportData/exportData";
import SelectPerson from "@/components/SelectPersonnel/person";
import SelectDepartment from "@/components/SelectDepartment/department";
import { mapGetters } from "vuex";
import workFlow from "@/mixins/workFlow";
import moment from "moment"
export default {
  name: "ContractCompleteList",
  mixins: [workFlow],
  data() {
    return {
      checkUserList: [],
      searchForm: {},
      tableConfig: contractCompleteListConfig(
        this.getMoney,
        this.selectPersonClick
      ),
      filterConfig: "",
      exportUrl: "",
      tableData: [],
      selectionList: [],
      page: {
        currentPage: 1,
        total: 0,
        layout: "total,pager,prev, next",
        background: false,
        pageSize: 10,
      },
      menuButtonConfig: {
        addBtn: true,
        addBtnTwo: true,
        editBtn: false,
        deleteBtn: true,
        exportBtn: true,
      },
    };
  },
  components: {
    CommonSelect,
    TableList,
    TagsCloud,
    SelectPerson,
    SelectDepartment,
    ExportData,
  },
  computed: {
    ...mapGetters(["userInfo", "permission"]),
  },
  mounted() {},
  methods: {
    goDetail(data) {
      if (!this.permission.contractComplete_view) {
        this.$message.error("没有查看权限");
        return;
      }
      this.$router.push({
        path: `/factoring/contractComplete/contractCompleteDetail/${data.id}`,
      });
    },

    handleEdit() {
      if (this.selectionList.length > 1) {
        this.$message.error("只能选择一条数据进行编辑");
      } else if (this.selectionList.length == 1) {
        let data = this.selectionList[0];
        if (data.auditStatus == 0) {
          if (
            data.managerUser == this.userInfo.user_id ||
            data.assistUser == this.userInfo.user_id
          ) {
            this.$router.push({
              path: `/factoring/contractComplete/editContractComplete/${data.id}`,
            });
          } else {
            this.$message.warning("您暂无权限对该条数据进行编辑");
          }
        } else {
          this.$message.warning("该条数据已提交审核无法编辑");
        }
      } else {
        this.$message.error("请选择一条数据进行编辑");
      }
    },

    handleAdd() {
      this.$router.push({
        path: "/factoring/contractComplete/addcontractComplete",
      });
    },

    selectPersonClick() {
      this.$refs.selectperson.showmode();
    },

    setPeople(val) {
      this.checkUserList = val;
      // this.getVisitPeople();
      let people = val.map((item) => {
        return item.realName;
      });
      let ids = val.map((item) => {
        return item.id;
      });
      this.searchForm.managerUser = ids.join(",");
      this.searchForm.managerUserName = people.join(",");
    },

    setContract(data) {
      this.searchForm.sellerCustName = data.custName;
      this.searchForm.contractName = data.contractName;
    },
    setSellerCust(data) {
      this.searchForm.sellerCustId = data.id;
    },
    cloudTages(data) {
      this.searchForm = data;
    },

    save(row) {
      this.$refs.cloudtage.save(row);
    },

    selectionChange(list) {
      this.selectionList = list;
    },

    searchChange(str, done) {
      this.queryTableData();
      done();
    },

    searchReset() {
      this.searchForm = {};
      this.queryTableData();
    },

    async queryTableData() {
      let params = {
        current: this.page.currentPage,
        size: this.page.pageSize,
        ...this.searchForm,
        createDateBegin: this.searchForm.timePic&&this.searchForm.timePic.length>0
          ? moment(this.searchForm.timePic[0]).format("YYYY-MM-DD")
          : undefined,
        createDateEnd: this.searchForm.timePic&&this.searchForm.timePic.length>0
          ? moment(this.searchForm.timePic[1]).format("YYYY-MM-DD")
          : undefined,
      };
      let res = await completeList(params);
      if (res.data.code == 200) {
        this.tableData = res.data.data.records;
        this.page.total = res.data.data.total;
      } else {
        this.$message.error(res.data.msg);
      }
    },

    async handleDelete() {
      let self = this;
      let startDelete = () => {
        self
          .$confirm("确定删除选择的数据?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
          .then(() => {
            self.deleteData();
          })
          .catch(() => {
            self.$message({
              type: "info",
              message: "已取消删除",
            });
          });
      };
      if (this.selectionList.length > 1) {
        this.$message.error("只能选择一条数据进行删除");
      } else if (this.selectionList.length == 1) {
        if (
          this.selectionList[0].managerUser == this.userInfo.user_id ||
          this.selectionList[0].assistUser == this.userInfo.user_id
        ) {
          let data = this.selectionList[0];
          if (data.flowableId != "" && data.auditStatus == 1) {
            // 获取流程数据
            await this.queryFlowData(data.flowableId);
            let presentFlow = this.flowData[this.flowData.length - 1];
            if (
              this.processDetail.flow[2].historyActivityId ==
              presentFlow.historyActivityId
            ) {
              startDelete();
            } else {
              this.$message.error("流程审批中不能删除");
            }
          } else {
            // 直接弹框提示
            startDelete();
          }
        } else {
          this.$message.error("您没有权限删除此条数据");
        }
      } else {
        this.$message.error("请选择数据进行删除");
      }
    },

    // 删除参数ids 提取this.selectionList中的id用,隔开成字符串
    async deleteData() {
      let ids = this.selectionList.map((item) => {
        return item.id;
      });
      let res = await completeDelete({ ids: ids.join(",") });
      if (res.data.code == 200) {
        this.$message.success("删除成功");
        // 刷新列表
        this.queryTableData();
      }
    },

    exportShow() {
      this.$refs.exportData.showModel();
    },

    exportDownload(value) {
      let page = this.page;
      let data = {
        export: value.code,
        auditState: 1,
      };
      if (value.code == 1) {
        data = {
          ...data,
          firstNum: (page.currentPage - 1) * page.pageSize,
          num: page.pageSize,
          ...this.searchForm,
        };
      } else if (value.code == 2) {
        data = {
          ...data,
          ...this.searchForm,
        };
      }
      downLoadTemplate("/api/bl/blcontractfinish/export", data, "get").finally(
        () => {
          this.loading = false;
          this.$message({
            type: "success",
            message: "已下载",
          });
        }
      );
    },
  },
};
</script>
<style lang="scss" scoped>
.contract-complete-list {
  .topcrud {
    line-height: 45px;
    font-size: 18px;
    background: #f9f9f9;
    border-radius: 15px 15px 0 0;
    text-indent: 25px;
    // margin: 0 5px;
    border-bottom: 1px solid #e9e9e9;
    .messagetitle {
      font-weight: bolder;
    }
  }
  .manage-table {
    background: #ffff;
    padding: 25px;
  }
  .project-name {
    // overflow: hidden;
    // white-space: nowrap;
    // text-overflow: ellipsis;
    color: #409eff;
  }
  .project-name:hover {
    color: #409eff;
    cursor: pointer;
  }
}
</style>